// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqNumber)).eq)();
const WeightsIsSymbol = {reflectSymbol: () => "Weights"};
const udecodeMap = /* #__PURE__ */ Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString);
const encodeMap = /* #__PURE__ */ Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId);
const encodeMap1 = /* #__PURE__ */ encodeMap(Foreign$dGeneric$dClass.numberEncode)({
  encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
});
const decodeMap = /* #__PURE__ */ Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId);
const decodeMap1 = /* #__PURE__ */ decodeMap(Foreign$dGeneric$dClass.numberDecode)({
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.numberDecode.decode}),
  decodeSingleRecordArg: Data$dMaybe.Nothing
});
const Weights = x => x;
const toFillFormTypeWeights = {fillFormDataType: v => "unknown"};
const newtypeWeights_ = {Coercible0: () => {}};
const eqWeights = {eq: x => y => eq(x)(y)};
const genericWeights = {to: x => x, from: x => x};
const showWeights = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dShow.showNumber));
      return {genericShowArgs: v => [$0.show(v)]};
    })())(WeightsIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeWeights = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = udecodeMap(udecodeMap(Unscramble.decodeNumber1));
    return x => $0.unsafeDecode(x);
  })()
};
const encodeWeights = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericWeights)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(WeightsIsSymbol)(/* #__PURE__ */ (() => {
    const encode1 = encodeMap(encodeMap1)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeMap1.encode(v)), Data$dList$dTypes.Nil)
    }).encode;
    return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)};
  })()))
};
const decodeWeights = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericWeights)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(WeightsIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = decodeMap(decodeMap1)({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeMap1.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      }).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  Weights,
  WeightsIsSymbol,
  decodeMap,
  decodeMap1,
  decodeWeights,
  encodeMap,
  encodeMap1,
  encodeWeights,
  eq,
  eqWeights,
  genericWeights,
  newtypeWeights_,
  showWeights,
  toFillFormTypeWeights,
  udecodeMap,
  unscrambleDecodeWeights
};
